<div class="broken" *ngIf="!this.href">
  <div class="logo">
    <img src="/assets/images/docorga-white.png" />
  </div>
  <div class="wrapper ui text inverted container" *ngIf="!this.href">
    <h1 class="ui inverted massive header">
      Flûte !
      <div class="sub header">Impossible de trouver la page que vous demandez</div>
    </h1>
    <p class="ui inverted text">
      Si vous avez suivi un lien depuis un mail, il est possible que celui-ci soit périmé. Prenez contact avec votre
      praticien afin qu'il vous en envoie un nouveau.
    </p>
  </div>
  <div class="wrapper ui text inverted container" *ngIf="!!this.href">
    <h1 class="ui inverted massive header">
      Flûte !
      <div class="sub header">Vous utilisez un lien de notre ancien site web.</div>
    </h1>
    <p class="ui inverted text">
      Vous allez être redirigé sur le nouveau site web vers la page correspondant à votre lien.<br />
      Si rien ne se passe, vous pouvez y accéder en <a href="{{ this.href }}">cliquant içi</a>
    </p>
  </div>
</div>
